export enum MetadataEditingType {
  flow = 0,
  user = 1,
  pool = 3
}
